import { Box, Button, Heading, Text, VStack } from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'
import { ImgSah } from '../../components/ImgSah'

export default function NotFound(): JSX.Element {
  return (
    <Box
      minH="100vh"
      bg="blue.50"
      display="flex"
      alignItems="center"
      justifyContent="center"
      px={6}
    >
      <VStack spacing={6} textAlign="center">
        <Heading fontSize="120px" color="blue.600" lineHeight="1">
          404
        </Heading>

        <Text fontSize="24px" fontWeight="bold" color="blue.700">
          Página não encontrada
        </Text>

        <Text maxW="400px" fontSize="16px" color="blue.600">
          Desculpe, não conseguimos encontrar a página que você está procurando.
          Verifique a URL ou volte para a página inicial.
        </Text>
        <ImgSah/>
        <Button
          as={RouterLink}
          to="/"
          bg="blue.600"
          color="white"
          _hover={{ bg: 'blue.700' }}
          px={8}
          py={6}
          fontSize="16px"
          rounded="lg"
        >
          Voltar para o início
        </Button>
      </VStack>
    </Box>
  )
}
